module.exports = __webpack_public_path__ + "img/paymentIcon.847215a1.png";